import { getSupplierSettings } from "@/http/resources/suppliers/settings";
import { useAuth } from "@/store/auth";
import useSWR from "swr";

export const useSettings = () => {
  const { user } = useAuth();

  const { data: tenantSettingsData } = useSWR(
    user?.id ? (["supplier-settings", user.id] as const) : null,
    getSupplierSettings
  );

  const taxes = tenantSettingsData?.settings?.products?.taxes ?? [];
  const hasTaxes = taxes.length > 0;
  const hasLegacySubOrders = !!tenantSettingsData?.settings?.orders?.legacySubOrders;
  const hasScheduledDeliveries = !!tenantSettingsData?.settings?.orders?.scheduledDeliveries;
  const hasUnitTypes = !!tenantSettingsData?.settings?.products?.unitTypes;
  const searchTypeInput = tenantSettingsData?.settings?.products?.searchTypeInput ?? "FULL_SEARCH";
  const searchDefaultSort = tenantSettingsData?.settings?.products?.searchDefaultSort ?? "SYSTEM";

  // `clients` may be null/undefined for tenants whose settings predate the
  // section — fall back to "list" so the UI always has a value to apply.
  const rawClientsDefaultView = tenantSettingsData?.settings?.clients?.defaultView;
  const clientsDefaultView: "list" | "kanban" =
    rawClientsDefaultView === "kanban" ? "kanban" : "list";

  return {
    taxes,
    hasTaxes,
    hasLegacySubOrders,
    hasScheduledDeliveries,
    hasUnitTypes,
    searchTypeInput,
    searchDefaultSort,
    clientsDefaultView,
    isSettingsLoaded: tenantSettingsData !== undefined,
  };
};
